module.exports = require('./getCookieValue')
